import { useI18n } from '../i18n.tsx';

export function Legend() {
  const { t } = useI18n();
  return (
    <div className="text-xs flex items-center gap-4">
      <span className="flex items-center gap-1">
        <span className="inline-block w-3 h-3 rounded bg-slate-300" /> {t('legend.none', 'No status yet')}
      </span>
      <span className="flex items-center gap-1">
        <span className="inline-block w-3 h-3 rounded bg-emerald-500" /> {t('legend.ok', 'OK (200)')}
      </span>
      <span className="flex items-center gap-1">
        <span className="inline-block w-3 h-3 rounded bg-rose-500" /> {t('legend.incident', 'Incident (500)')}
      </span>
    </div>
  );
}
